export class PaymentRequest{
    customer:any;
    address:any;
    payment: any;
}